import { t } from "@/i18n-js/instance";
import { ListingCard } from "./ListingCard";

interface SpaceListingCardProps {
  resources: Array<{ name: string; id: string }>;
}

export const SpaceListingCard = ({ resources }: SpaceListingCardProps) => (
  <ListingCard
    title={t("help_widget.copilot.chat_card.spaces")}
    resources={resources}
    emptyStateText={t("help_widget.copilot.chat_card.no_spaces_found")}
    renderItem={space => space.name}
    getItemKey={space => space.id}
  />
);
